module.exports = __webpack_public_path__ + "static/media/logo-criipto-white-2.e4ac1f94.svg";